import { Box, FormLabel } from '@chakra-ui/react';
import clsx from 'clsx';
import * as React from 'react';
import { FieldError } from 'react-hook-form';

type FieldWrapperProps = {
  label?: string;
  className?: string;
  children: React.ReactNode;
  size?: string;
  error?: FieldError | undefined;
  description?: string;
  w?: string;
};

export type FieldWrapperPassThroughProps = Omit<FieldWrapperProps, 'className' | 'children'>;

export const FieldWrapper = (props: FieldWrapperProps) => {
  const { label, className, error, children, size = 'md'} = props;
  return (
    <Box w={props.w}>
      <FormLabel className={clsx('', className)} size={size}>
        {label}
        <div className="mt-1">{children}</div>
      </FormLabel>
      {error?.message && (
        <div role="alert" aria-label={error.message} className="text-sm font-semibold text-red-500">
          {error.message}
        </div>
      )}
    </Box>
  );
};
